const PopularIcon = ({ className }) => (
  <svg
    className={className}
    width="13"
    height="13"
    viewBox="0 0 11 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.81038 0.347813L6.94322 2.63272C7.02839 2.80481 7.19289 2.92382 7.38364 2.95124L9.99867 3.32921C10.4782 3.39862 10.6695 3.98663 10.3225 4.3238L8.43189 6.1584C8.29364 6.29256 8.23061 6.48564 8.26327 6.67522L8.6955 9.1859C8.783 9.69515 8.2481 10.0836 7.7896 9.84389L5.52163 8.65682C5.3513 8.56757 5.14828 8.56757 4.97853 8.65682L2.71228 9.84272C2.25319 10.0831 1.71651 9.69396 1.80459 9.18355L2.23689 6.67522C2.26956 6.48564 2.20652 6.29256 2.06827 6.1584L0.17771 4.3238C-0.169957 3.98663 0.0213368 3.39862 0.50142 3.32921L3.11652 2.95124C3.30669 2.92382 3.47119 2.80481 3.55694 2.63272L4.68979 0.347813C4.91787 -0.115938 5.58055 -0.115938 5.81038 0.347813Z"
      fill="white"
    />
  </svg>
);

export default PopularIcon;
